<template>
  <div>
    <s-form @submit="createProduct">
      <p class="m-form-group">
        <label class="a-form-label" for="name">{{ $t('label-product-name') }}*</label>
        <input class="a-form-control" id="name" v-model.trim="$v.name.$model" autocomplete="add-product product-name" />
        <span v-if="$v.name.$dirty">
          <span class="m-form-group__error" v-if="!$v.name.required">{{ $t('error-field-required') }}</span>
        </span>
      </p>

      <p class="m-form-group">
        <label class="a-form-label" for="description">{{ $t('label-product-description') }}</label>
        <input class="a-form-control" id="description" v-model="description" autocomplete="add-product product-description" />
      </p>

      <div class="h-grid">
        <div class="h-grid__col h-grid__col--xxs-6">
          <p class="m-form-group">
            <label class="a-form-label" for="price">{{ $t('label-product-price') }}*</label>
            <input type="number" class="a-form-control" id="price" v-model.trim="$v.price.$model" step="0.01" min="0" autocomplete="add-product product-price" />
            <span v-if="$v.price.$dirty">
              <span class="m-form-group__error" v-if="!$v.price.required">{{ $t('error-field-required') }}</span>
            </span>
          </p>
        </div>
      </div>

      <p class="m-form-group">
        <button class="a-btn-primary a-btn-primary--small" type="submit">
          {{ productEditing ? $t('button-edit-product') : $t('button-create-product') }}
        </button>
      </p>
    </s-form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import SForm from '@/components/form/form'

export default {
  components: {
    SForm
  },
  props: {
    productEditing: {
      validator: prop => {
        return typeof prop === 'object' || prop === null
      },
      required: false,
      default: null
    }
  },
  created: function() {
    if (this.productEditing) {
      this.name = this.productEditing.Name
      this.description = this.productEditing.Description
      this.price = this.productEditing.Price
    }
  },
  data() {
    return {
      name: '',
      description: '',
      price: ''
    }
  },
  methods: {
    createProduct: async function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('saveProduct', { Name: this.name, Description: this.description, Price: this.price })
      }
    }
  },
  validations: {
    name: {
      required
    },
    price: {
      required
    }
  }
}
</script>
